import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLang } from '../utils/LanguageContext';
import { useAuth } from '../utils/AuthContext';
import { t } from '../utils/translations';
import './Navbar.css';

function Navbar() {
  const location = useLocation();
  const { lang, toggleLang } = useLang();
  const { org, role, isPro, isEvents, branches, switchBranch, signOut } = useAuth();
  const [confirmLogout, setConfirmLogout] = useState(false);
  const tr = t[lang];

  const canManage = role === 'owner' || role === 'manager';
  const multiBranch = branches.length > 1;

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <img className="navbar-logo" src={process.env.PUBLIC_URL + '/logo192.png'} alt="" />
        {multiBranch ? (
          <select
            className="branch-select"
            value={org?.id || ''}
            onChange={e => switchBranch(e.target.value)}
            title={tr.branchesTitle}
          >
            {branches.map(b => (
              <option key={b.id} value={b.id}>{b.name}</option>
            ))}
          </select>
        ) : (
          org?.name || 'StratosPOS'
        )}
      </div>
      <div className="navbar-links">
        {isEvents ? (
          <>
            <Link to="/" className={location.pathname === '/' ? 'active' : ''}>{tr.reservations}</Link>
            {canManage && (
              <Link to="/settings" className={location.pathname === '/settings' ? 'active' : ''}>⚙️</Link>
            )}
          </>
        ) : (
          <>
            <Link to="/" className={location.pathname === '/' ? 'active' : ''}>{tr.order}</Link>
            <Link to="/history" className={location.pathname === '/history' ? 'active' : ''}>{tr.history}</Link>
            {isPro && (
              <Link to="/carnet" className={location.pathname === '/carnet' ? 'active' : ''}>📒</Link>
            )}
            {canManage && (
              <>
                <Link to="/menu" className={location.pathname === '/menu' ? 'active' : ''}>{tr.menu}</Link>
                <Link to="/analytics" className={location.pathname === '/analytics' ? 'active' : ''}>{tr.stats}</Link>
                <Link to="/dayclose" className={location.pathname === '/dayclose' ? 'active' : ''}>🧾</Link>
                <Link to="/settings" className={location.pathname === '/settings' ? 'active' : ''}>⚙️</Link>
              </>
            )}
          </>
        )}
        <button className="lang-btn" onClick={toggleLang}>
          {lang === 'fr' ? 'FR' : lang === 'en' ? 'EN' : 'ع'}
        </button>
        <button className="logout-btn" onClick={() => setConfirmLogout(true)} title={tr.logout}>🔒</button>
      </div>

      {confirmLogout && (
        <div className="logout-overlay" onClick={() => setConfirmLogout(false)}>
          <div className="logout-modal" onClick={e => e.stopPropagation()}>
            <div className="logout-icon">🔒</div>
            <p className="logout-question">{tr.logoutConfirm}</p>
            <div className="logout-actions">
              <button className="logout-cancel" onClick={() => setConfirmLogout(false)}>
                {tr.cancel}
              </button>
              <button className="logout-yes" onClick={signOut}>
                {tr.logout}
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
